import { css } from '@microsoft/fast-element';

export const TimerBarStyles = css`
  .timer-bar {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
  }

  .timer-bar-background {
    flex-direction: row;
    display: flex;
    width: 200px;
    border-radius: 3px;
    padding-right: 7px;
  }

  .timer-bar-foreground {
    width: 100%;
    height: 7px;
    border-radius: 3px;
  }

  .timer-bar-hhmmss {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 80px;
    color: #c7ff8c;
    box-sizing: border-box;
  }

  .timer-bar-icon {
    display: flex;
    flex-direction: row;
    width: 25px;
    height: 25px;
    justify-content: center;
    align-items: center;
    padding-left: 7px;
    padding-right: 5px;
  }

  .timer-bar-server-info {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
  }
`;
